




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ScoreItem } from './components';
import { IScore } from './types';

@Component({
  components: {
    ScoreItem,
  },
})
export default class Score extends Vue implements IScore {
  @Prop({ type: String, default: '' })
  readonly certificateType!: string;

  @Prop({ type: String, default: '' })
  readonly certificateAmountTotal!: string;

  @Prop({ type: String, default: '' })
  readonly certificateAmountOnHold!: string;

  @Prop({ type: String, default: '' })
  readonly certificateAmountWithdraw!: string;

  @Prop({ type: String, default: '' })
  readonly certificateAmountCurrent!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/score/Score.vue